import type { SourceApiRecord } from './interfaces';
import entityNameFromPatchPath from './patchMap';

function _isObject(object: unknown): object is Record<string, unknown>[] {
    if (!object || typeof object !== 'object') {
        return false;
    }
    return true;
}

function _isArrayRecords(object: unknown): object is Record<string, unknown>[] {
    if (!object || !Array.isArray(object)) {
        return false;
    }

    const records: unknown[] = object;

    for (const record of records) {
        if (!_isObject(record)) {
            return false;
        }
    }

    return true;
}

export function siteDataResponseToEntityMap(patchData: Record<string, unknown>): SourceApiRecord {
    const applicator: Partial<SourceApiRecord> = {};
    const keys = Object.keys(patchData);
    for (const patchPath of keys) {
        if (patchPath === 'hash') {
            continue;
        }

        let items = patchData[patchPath];

        /* '/site' comes back as an Object, not an array. make sure all added are arrays */
        if (!Array.isArray(items)) {
            items = [items];
        }

        if (!_isArrayRecords(items)) {
            throw new Error(
                `Unexpected data, expecting array of records, ${JSON.stringify(items)}`,
            );
        }

        const entityName = entityNameFromPatchPath(patchPath);

        if (!entityName) {
            continue;
        }

        applicator[entityName] = items;
    }

    return applicator as SourceApiRecord;
}
